/**
 * Created by dx.yang on 16/6/15.
 */


import suid from '../../services/suid';

export default {
    name: 'KsSelect',

    props: {
        search: {
            type: Boolean,
            required: false,
            default: false
        },
        options: {
            type: Array,
            required: true,
            default: () => []
        },
        value: {
            default: () => null
        },
        mode: {
            type: String,
            required: false,
            default: 'click'
        },
        group: {
            type: Array,
            required: false,
            default: () => []
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }

    },

    computed: {
        optionsFiltered() {
            if (this.filterString) {
                return _.filter(this.options, (v) => v.title.indexOf(this.filterString) != -1);
            }
            if(this.needGroup) {
                return this.options.filter(item=>{
                    return item.group === this.currentGroup
                });
            } else {
                return this.options
            }
        },
        currentSelected() {
            var me = this;
            return me.value ? me.value.title : '<span class="text-muted">' + me.$trans(`请选择`) + '</span>';
        },
        needGroup() {
            return this.group.length > 0 ? true : false
        }
    },
    watch: {
        group: {
            deep: true,
            handler() {
                if (this.needGroup) {
                    this.currentGroup = this.group[0].value;
                }
            },
        },
        needGroup(val) {
            var me = this;
            if(val) {
                me.currentGroup = me.group[0].value;
            }
        }
    },
    data() {
        return {
            uuid: '',
            filterString: '',
            open: false,
            mouseTimer: null,
            currentGroup: null
        };
    },
    mounted() {
        var me = this;
        this.$nextTick(() => {
            me.uuid = suid('ks-select');
            $(document).on('click', me.closeMe).on('ks-select-click',  me.closeMe);
            if(me.needGroup) {
                me.currentGroup = me.group[0].value;
            }
        })
    },
    destroyed() {
        var me = this;
        $(document).off('click', me.closeMe).off('ks-select-click',  me.closeMe);
    },

    methods: {
        closeMe(e, data) {
            if (data === this.uuid) {
                return;
            }
            this.open = false;
        },

        selectOne(item) {
            this.$emit('input', item);
            this.filterString = '';
            this.open = false;
        },

        selectGroup(item) {
            var me = this;
            me.currentGroup = item.value;
        },
        clickHandler(e) {
            if (this.mode !== 'click') {
                return;
            }
            if (e.target.tagName.toLocaleLowerCase() === 'input') {
                return;
            }

            this.open = !this.open;

            // 点击一个ks-select, 由于不冒泡, so触发一个自定义事件
            // 捕捉到这个事件的ks-select检查是否是自己触发的
            // 不是自己触发, 则将自己的状态改为关闭
            this.$nextTick(() => {
                $(document).trigger('ks-select-click', [this.uuid]);
                this.$forceUpdate();
            });

        },

        mouseoverHandler() {
            if (this.mode !== 'hover') {
                return;
            }
            clearTimeout(this.mouseTimer);
            this.mouseTimer = null;
            this.open = true;
        },
        mouseoutHandler() {
            if (this.mode !== 'hover') {
                return;
            }
            var me = this;
            me.mouseTimer && clearTimeout(me.mouseTimer);
            me.mouseTimer = setTimeout(() => {
                me.open = false;
            }, 200);
        }

    }


};
